import { render, staticRenderFns } from "./ShowList.vue?vue&type=template&id=89d0af60"
import script from "./ShowList.vue?vue&type=script&lang=ts"
export * from "./ShowList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports